import React, { ReactElement } from "react";

import "./CellDetailsMobile.scss";

interface CellDetailsMobileArgs {
  id: string;
  header: ReactElement | string;
  value?: ReactElement | string;
}

export const CellDetailsMobile = ({
  id,
  header,
  value,
}: CellDetailsMobileArgs) => {
  if (!value) return null;

  return (
    <td role="cell" className={`cell-details-mobile td td--details td--${id}`}>
      <div className="cell-details-mobile__header">{header}</div>
      <div className="cell-details-mobile__value">{value}</div>
    </td>
  );
};
